import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';

@Component({
  selector: 'app-field',
  template: ``,
})

export class FieldComponent implements OnInit {
  @Input() public RealValue;
  @Input() public Title: string;
  @Input() public Comment: string;
  @Input() public FrontDecor: string;
  @Input() public RearDecor: string;

  constructor() {
  }

  ngOnInit() {
  }
}
